// extracted by mini-css-extract-plugin
export default {"phone":"phone_fjX0VVfq","phone-number":"phone-number_R39pZ2RV"};